import { Address, BeneficiaryTransferDestination, IntermediaryBank } from './beneficiaries'

export interface PayoutsV2PostAuthRequest {
  challenge: string
  tokenResponse: string
  mfaCallbackUrl: string
}

export interface PayoutsV2PostAuthResponseOriginator {
  amount: number
  currency: string
  entity: {
    legalName: string
    type: string
  }
  walletId: string
}

export interface PayoutsV2PostAuthResponseBeneficiary {
  amount: number
  currency: string
  entity: {
    legalName: string
    type: string
  }
  relationshipType: string
  address: Address
  type: string
  remittanceInformation: string
  bankAccount: {
    accountNumber: string
    bank: {
      identificationCode: string
      address: Address
    }
    intermediaryBanks: IntermediaryBank[]
  }
}

interface PayoutsV2PostAuthResponseFees {
  processingFee?: {
    amount: number
    currency: string
  }
}

export interface PayoutsV2PostAuthResponse {
  id: string
  method: string
  status: string
  fees?: PayoutsV2PostAuthResponseFees
  originator: PayoutsV2PostAuthResponseOriginator
  beneficiary: PayoutsV2PostAuthResponseBeneficiary
  trackingDetails: Record<string, string>[]
  createdAt: string
  updatedAt: string
  direction: string
  type: string
}

export interface ConfirmPayeeRequest {
  accountNumber: string
  bankCode: string
  currency: string
  businessName?: string
  firstName?: string
  lastName?: string
}

export interface ConfirmPayeeBeneficiaryParams extends ConfirmPayeeRequest {
  transferDestination: BeneficiaryTransferDestination
}

export const ConfirmPayeeMatchStatuses = {
  MATCH: 'MATCH',
  NO_MATCH: 'NO_MATCH',
  PARTIAL_MATCH: 'PARTIAL_MATCH',
  TECHNICAL_ERROR: 'TECHNICAL_ERROR',
  NOT_POSSIBLE: 'NOT_POSSIBLE',
  NOT_REQUIRED: 'NOT_REQUIRED',
}

export type ConfirmPayeeMatchStatus =
  (typeof ConfirmPayeeMatchStatuses)[keyof typeof ConfirmPayeeMatchStatuses]

export interface ConfirmPayeeResponse {
  id: string
  matchStatus: ConfirmPayeeMatchStatus
  providedName: string
  reasonCode: string
  actualName: string
}

export interface OrchestratedConfirmPayeeName {
  firstName?: string
  lastName?: string
  businessName?: string
}
